<tpm-card no-padding class="marketplace-carousel-item" variant="elevation-basic-10">
  <div
    class="marketplace-carousel-item-container"
    [class.marketplace-carousel-item-container--mobile]="isMobile"
    [class.marketplace-carousel-item-container--no-teaser-image]="!props.teaserImage"
  >
    <div
      *ngIf="!isMobile"
      class="marketplace-carousel-item__asset-container marketplace-carousel-item__asset-container--divider"
    >
      <img class="image logo" [ngSrc]="props.logo" fill />
    </div>
    <div class="marketplace-carousel-item__body">
      <p class="headline last-line-2">{{ props.teaserInfo }}</p>
      <div *ngIf="!!props.price" class="price" [class.price--overlapped]="!isMobile && !!props.teaserImage">
        {{ props.price + "&nbsp;€" }}
      </div>
    </div>
    <div *ngIf="!isMobile && !!props.teaserImage" class="marketplace-carousel-item__asset-container">
      <img class="image teaser-image" [ngSrc]="props.teaserImage" fill />
    </div>
  </div>
</tpm-card>
